import { type RequestPayload, router } from "@inertiajs/core";
import { AdminForm } from "../../../components/admin/AdminForm";
import { getFullName } from "../../../helpers/stringHelper";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import type { Coach } from "../../../models/coach";
import { admin_path, admins_path } from "../../../routes";

type AdminEditProps = {
  admin: Coach;
};

export default function AdminEdit({ admin }: AdminEditProps) {
  const { pathWithYearContext } = useYearContext();
  const onSubmit = (values: RequestPayload) => router.patch(pathWithYearContext(admin_path, admin.id), values);

  return (
    <ContentShell title={`Admin ${getFullName(admin)}`} onBack={() => router.get(pathWithYearContext(admins_path))}>
      <AdminForm admin={admin} submitButtonLabel="Speichern" onSubmit={onSubmit} />
    </ContentShell>
  );
}
